const SE1_2026 = new Date(2026, 0, 4); // 4 de janeiro de 2026 (mês 0=jan)

export function dataParaSE(data: Date): number {
  const delta = Math.floor((data.getTime() - SE1_2026.getTime()) / (1000 * 60 * 60 * 24));
  return Math.floor(delta / 7) + 1;
}

export function sePraIntervalo(se: number): { inicio: Date; fim: Date } {
  const inicio = new Date(SE1_2026);
  inicio.setDate(inicio.getDate() + (se - 1) * 7);
  const fim = new Date(inicio);
  fim.setDate(fim.getDate() + 6);
  return { inicio, fim };
}

export function formatarSE(se: number): string {
  if (!se || se < 1 || se > 53) return "—";
  const { inicio, fim } = sePraIntervalo(se);
  const fmt = (d: Date) => d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  return `SE ${se} (${fmt(inicio)} – ${fmt(fim)})`;
}
